import {Distribution, _Distribution} from './distribution';

/**
 * Generated from com.dataiku.dip.eda.compute.distributions.Beta
 */
export interface Beta extends _Distribution {
    // PolyJson type
    type: 'beta';
}

export function isBeta(toTest: Distribution): toTest is Beta { return 'beta' === toTest.type; }

export namespace Beta {
    /**
     * Generated from com.dataiku.dip.eda.compute.distributions.Beta$FittedBeta
     */
    export interface FittedBeta extends Distribution._FittedDistribution {
        alpha: number;
        beta: number;
        lower: number;
        upper: number;

        // PolyJson type
        type: 'beta';
    }

    export function isFittedBeta(toTest: Distribution.FittedDistribution): toTest is FittedBeta { return 'beta' === toTest.type; }
}